import { Observable } from 'rxjs';
import { Action } from 'redux';
import { ofType, StateObservable } from 'redux-observable';
import { concatMap, filter, map, withLatestFrom } from 'rxjs/operators';
import { GET_SUBSCRIPTION_SUCCESS } from '../actions';
import { GetSubscription, GetSubscriptionSuccess } from '../action-creators';
import { promiseDelay } from '../../../utils/promise-delay';
import { NoOp } from '../../ui/action-creators';
import { CreateOrder } from '../../orders/action-creators';
import AppState from '../../state';

export const validateSubscriptionEpic = (
  action$: Observable<Action>,
  state$: StateObservable<AppState>
) =>
  action$.pipe(
    ofType<Action, GetSubscriptionSuccess>(GET_SUBSCRIPTION_SUCCESS),
    filter(
      (action) =>
        !action.subscription.isActive &&
        action.subscription.plan.toUpperCase() !== 'BEGINNER'
    ),
    withLatestFrom(state$),
    map(async ([action, state]) => {
      if (!waitedEnough(new Date(action.subscription.updated_at))) {
        await promiseDelay(Math.min(30, Math.pow(action.retries, 2)) * 1000);
        return new GetSubscription(
          action.subscription.clientId,
          true,
          (action.retries || 0) + 1
        );
      }

      let createOrder: Action = new NoOp();
      const orderExists = state.orders.basket.some((o) => {
        return (
          o.product.id === action.subscription.product.id &&
          o.price.id === action.subscription.price.id &&
          o.price.frequency === action.subscription.price.frequency
        );
      });

      if (!orderExists) {
        const product = state.products.list.find(
          (p) => p.id === action.subscription.product.id
        );
        const price = product?.prices.find(
          (p) => p.id === action.subscription.price.id
        );
        if (product && price) {
          createOrder = new CreateOrder({
            product,
            price,
            quantity: 1,
          });
        }
      }

      return createOrder;
    }),
    concatMap((actions) => actions)
  );

const waitedEnough = (date: Date): boolean => {
  const delta = 5 * 60 * 1000;
  const limit = Number(new Date()) - delta;

  return Number(date) < limit;
};
